import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios/axiosInstance';

export const fetchAllProperties = createAsyncThunk(
  'admin/fetchAllProperties',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/properties/all-properties', { params });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const updateProperty = createAsyncThunk(
  'admin/updateProperty',
  async ({ propertyId, payload }, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      Object.entries(payload || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        // stringify arrays/objects (e.g., units_data)
        if (Array.isArray(value) || typeof value === 'object') {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      const { data } = await axiosInstance.patch(
        `/properties/op/${propertyId}`,
        formData
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Property update failed' }
      );
    }
  }
);

export const deleteProperty = createAsyncThunk(
  'admin/deleteProperty',
  async (propertyId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.delete(
        `/admin/properties/${propertyId}`
      );
      return { propertyId, data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: 'Property delete failed' }
      );
    }
  }
);
